import { useEffect, useState } from "react";

/**
 * Navigazione minimale basata su hash (#/nuova, #/r/42): funziona su qualunque
 * hosting statico e il tasto "indietro" del telefono torna alla schermata precedente.
 */
export type Route =
  | { name: "home" }
  | { name: "nuova" }
  | { name: "inviata"; id: number }
  | { name: "dettaglio"; id: number };

export function parseRoute(hash: string): Route {
  const [path = ""] = hash.replace(/^#/, "").split("?");
  const parts = path.split("/").filter(Boolean);
  if (parts[0] === "nuova") return { name: "nuova" };
  if (parts[0] === "r" && parts[1]) return { name: "dettaglio", id: Number(parts[1]) };
  if (parts[0] === "inviata" && parts[1]) return { name: "inviata", id: Number(parts[1]) };
  return { name: "home" };
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseRoute(window.location.hash));
  useEffect(() => {
    const onChange = () => {
      setRoute(parseRoute(window.location.hash));
      window.scrollTo(0, 0);
    };
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return route;
}

export const navigate = (path: string) => {
  window.location.hash = path;
};

/** Sostituisce la voce corrente (es. dopo l'invio, così "indietro" non riapre il modulo). */
export const replace = (path: string) => {
  window.location.replace(`${window.location.pathname}${window.location.search}#${path}`);
};

export const goBack = () => {
  if (window.history.length > 1) window.history.back();
  else navigate("/");
};
